export default __webpack_public_path__ + "static/media/npmStatsCore.be564d1e.png";